export const BtpData = [
  {
    id: 11,
    image: require("../assets/images/BTPMachines/bull96.webp"),
    title: "Tractopelle",
    products: [
      {
        id: 1,
        name: "BULL HD 100",

        descriptionPoints: [
          {
            description:
              "BULL Machines a déjà eu un impact sur le marché mondial en produisant des véhicules dédiés aux équipements de construction de classe mondiale, tout en restant le premier fabricant indien d'accessoires pour tracteurs depuis plus de 16 ans.",
          },
        ],

        image: require("../assets/images/BTPMachines/bull-100.webp"),
        images: [
          {
            image: require("../assets/images/BTPMachines/bull100.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/bull100-1.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/bull100-2.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/bull100-3.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/3-8gIrW7MHI", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          {
            key: "PUISSANCE MAXIMALE: ",
            value: "(74.9kw) 100/2200 (hp/tr/min)",
          },
          { key: "FORCE DE CAVAGE:", value: "3316 kgf" },
          { key: "HAUTEUR DE DÉVERSEMENT:", value: "2960 mm" },
        ],
        brochure: require("../assets/brochure/bull100.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Performance du chargeur",
            features: [
              { key: "Capacité de godet standard	", value: "1,1 m3 GP Showel" },
              { key: "Hauteur de vidage	", value: "2,96 m" },
              { key: "Charge sur hauteur	", value: "3,39 m" },
              { key: "Hauteur de la broche	", value: "3.61 m" },
              { key: "Épingle vers l'avant	", value: "0.42 m" },
              { key: "Atteindre au sol	", value: "1.47 m" },
              { key: "Atteindre à pleine hauteur	", value: "1.28 m" },
              { key: "Atteindre à pleine hauteur bkt Dumped	", value: "0.89 m" },
              {
                key: "Sous le niveau du sol Profondeur de creusement	",
                value: "0.1 m",
              },
              { key: "Recul au sol	", value: " 49 degré" },
              { key: "Angle de vidage	", value: "45 degré" },
              { key: "Force d'arrachement du godet	", value: "8793 kgf" },
              {
                key: "Force d'arrachement du bras du chargeur	",
                value: "5642 kgf",
              },
            ],
          },
          {
            id: 1,
            type: "Performance d'excavatrice",
            features: [
              { key: "Capacité de godet standard", value: "0,27 m3" },
              { key: "Profondeur d'excavation maximale", value: "4.60m" },
              {
                key: "Atteindre le niveau du sol au centre de la roue arrière",
                value: "6.80m	",
              },
              {
                key: "Atteindre le niveau du sol jusqu'au centre de pivotement",
                value: "5.50m",
              },
              {
                key: "Atteindre à pleine hauteur jusqu'au centre de pivotement",
                value: "2.85m",
              },
              { key: "Hauteur de travail maximale", value: "5.92m" },
              { key: "Charge maximale sur la hauteur", value: "4.14m" },
              { key: "Rotation du godet - Puissance	", value: "188 degré" },
              { key: "Force d'arrachement du godet	", value: "6851 kgf" },
              { key: "Dipper déchire notre force", value: "3316 kgf" },
              {
                key: "Capacité de levage du godet Pivot à pleine portée (sans godet)",
                value: "1400 kg",
              },
            ],
          },
        ],
      },
      {
        id: 12,
        name: "Autre Tractopelle",

        descriptionPoints: [
          {
            description:
              "ÉQUIPEMENTS DE CONSTRUCTION Chargeuse-pelleteuse de classe mondiale conservant les paramètres d'efficacité, de confort et de sécurité les plus élevés avec l'accréditation ROPS et FOPS.",
          },
        ],

        image: require("../assets/images/BTPMachines/bull96.webp"),
        images: [
          {
            image: require("../assets/images/BTPMachines/bull-96.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/bull-76-2wd.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/bull-76-4wd.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/bull-76-2wd-2.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/bull-76-4wd-2.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/-WFyyHs8TFg", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          {
            key: "BULL HD 76 4wd ",
            value:
              "a une transmission Carraro avec convertisseur de couple intégré avec options d'entraînement 2 WD et 4WD disponibles",
          },
          {
            key: "BULL HD 76 2wd",
            value:
              "a une transmission Carraro avec convertisseur de couple intégré. Il dispose d'une direction assistée avec des options d'entraînement 2 roues motrices et 4 roues motrices disponibles.",
          },
          {
            key: "BULL HD 96 4wd",
            value:
              "a le Kirloskar de 96 ch avec une puissance brute de 71,6 kW et une transmission Carraro.",
          },
        ],
        brochure: require("../assets/brochure/bull76_merged.pdf"),
        technicalFeatures: [],
      },
    ],
  },
  {
    id: 2,
    image: require("../assets/images/BTPMachines/ajax1000.webp"),
    title: "Auto - Bétonniaire",
    products: [
      {
        id: 1,
        name: "AJAX 1000",

        descriptionPoints: [
          {
            description:
              "La bétonnière à chargement automatique est la combinaison d'un camion malaxeur à béton et d'une bétonnière qui peut automatiquement alimenter, mesurer, mélanger et évacuer le mélange de béton. Equipé d'un moteur puissant et d'une direction à 4 roues, le malaxeur à béton à chargement automatique est comme une petite voiture et l'opérateur peut le conduire là où il doit aller.",
          },
        ],
        image: require("../assets/images/BTPMachines/ajax1000.webp"),
        images: [
          {
            image: require("../assets/images/BTPMachines/ajax1000.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/ajax10001.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/ajax10007.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/ajax10008.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/ajax10009.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/bwDoflyudw8", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Poids de la machine", value: "Poids à vide 3000 kg" },
          { key: "Capacité du seau", value: "250 litres" },
          { key: "Pneu à usage intensif", value: "10.0/75 X 15.3 - 18 PR" },
          { key: "Capacité du réservoir d'eau", value: "55 litres" },
        ],
        brochure: require("../assets/brochure/ArgoSeries.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Spécifications",
            features: [
              {
                key: "Moteur",
                value:
                  "M&M MDI 2800 32.80KW (45 ch) à 2300 tr/min Conforme aux émissions BSIII",
              },
              { key: "Poids de la machine", value: "Poids à vide 3000 kg" },
              { key: "Capacité du seau", value: "250 litres" },
              { key: "Pneu à usage intensif", value: "10.0/75 X 15.3 - 18 PR" },
              { key: "Capacité du réservoir d'eau", value: "55 litres" },
              { key: "Vitesse du véhicule", value: "0-17 km/h" },
              {
                key: "Capacité et sortie du tambour",
                value:
                  "Capacité du tambour : 1,7 m3/lot Sortie du tambour : 1 m3/lot",
              },
              { key: "Capacité du réservoir de carburant", value: "40 litres" },
            ],
          },
        ],
      },
      {
        id: 2,
        name: "Autres Auto - Bétonniaire",

        descriptionPoints: [
          {
            description:
              "L'Auto - Bétonniaire est très pratique pour charger des matériaux, tels que du ciment, des agrégats, de la pierre. La matière première est dispersée sur le chantier. Avec le mélangeur à chargement automatique, vous ne vous soucierez jamais du transport des matières premières. Le malaxeur à béton à chargement automatique efficace n'a besoin que d'un opérateur pour conduire, charger et mélanger les matières premières tout en les déplaçant. Il a une efficacité de travail plus élevée, un effet de mélange plus élevé. Dans le même temps, cela réduit considérablement les coûts de main-d'œuvre et le temps de travail. Les bétonneuses à chargement automatique peuvent vous apporter de grands avantages. Comparé au malaxeur mobile à béton, le camion malaxeur à béton mobile à chargement automatique.",
          },
        ],

        image: require("../assets/images/BTPMachines/ajax10005.webp"),
        images: [
          {
            image: require("../assets/images/BTPMachines/ajax10005.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/ajax10001.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/ajax10007.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/ajax10008.webp"),
          },
          {
            image: require("../assets/images/BTPMachines/ajax10009.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/0P7uwq31_8E", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          {
            key: "Ajax Argo 2800",
            value:
              "Garantit que la qualité de béton souhaitée est livrée conformément à la conception du mélange en permettant à l'opérateur de calibrer la quantité d'agrégats dans le mélangeur, des commandes de commutation conviviales, un clavier alphanumérique avec écran couleur TFT.",
          },
          {
            key: "Ajax Argo 2300",
            value:
              "Flux régulier des matériaux dans le tambour sans déversement",
          },
          {
            key: "Ajax Argo 2000",
            value:
              "Moins de consommation de carburant grâce au meilleur rapport poids/puissance de sa catégorie et au mode de mélange automatique.",
          },
        ],
        brochure: require("../assets/brochure/ArgoSeries.pdf"),
        technicalFeatures: [],
      },
    ],
  },
];
